import React from "react";
import { Box } from "@mui/material";
import { CircularProgress } from "@mui/material";
/*
Displays the CircularProgress icon in the center of the screen.
*/
export default function LoadingContent() {
  return (
    <Box
      style={{
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
      }}
    >
      <CircularProgress />
    </Box>
  );
}
